// extracted by mini-css-extract-plugin
module.exports = {"layout":"order-delivery_layout__AB1_U"};